{
  "version": 1,
  "asset_id": "6f347846-a015-4a21-8259-233447ac5425",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/6f347846-a015-4a21-8259-233447ac5425/floral-city-black-shingle-roof-installation-1320w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/6f347846-a015-4a21-8259-233447ac5425/floral-city-black-shingle-roof-installation-1320w.webp",
  "original_filename": "floral-city-black-shingle-roof-installation-1320w.webp",
  "size": 105096,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:52Z"
}
